<template>
  <footer class="foot">
    <div class="w1200 flexDiv">
      <div class="left">
        <p><img :src="footLogo.Logo" alt="" /></p>
        <ul>
          <li>地址：南京市江宁区铜山金铜路2号</li>
          <li>
            电话：400 809
            9055&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;招生办邮箱：zsb@jku.cn
          </li>
          <li>Coyright © 金肯职业技术学院 All rights reserved.</li>
          <li>
            <a href="https://beian.miit.gov.cn/" target="_blank"
              >苏ICP备11073940号-3</a
            >
            <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank"
              ><em></em>苏公网安备32011502012155号</a
            >
          </li>
        </ul>
      </div>
      <div class="right">
        <ul class="flexDiv wow fadeInRight" id="footer_ewm">
          <!-- <li><p><img src="img/zswx.png" alt=""></p><span>招生微信</span></li>
                    <li><p><img src="img/xsfw.png" alt=""></p><span>学生服务</span></li>
                    <li><p><img src="img/gfwb.png" alt=""></p><span>官方微博</span></li>-->
          <li v-for="(item, index) in codeData" :key="index">
            <p><img :src="item.Cover" alt="" /></p>
            <span>{{ item.Title }}</span>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "foot",
  data() {
    return {
      codeData: []
    };
  },
  created() {
    this.codeData = this.Base.GetNewsInfoByCid(5516, true, 1, "", 3);
    // console.log(this.codeData,'codeData')
    this.footLogo = this.Base.GetDepartmentByDid(260);
  }
};
</script>
<style lang="less" scoped>
.foot {
  height: 263px;
  background-color: #0376be;
}
footer .left p {
  width: 387px;
  height: 73px;
  margin: 30px 0 14px;
  img {
    object-fit: contain;
  }
}
footer .left li {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 28px;
  letter-spacing: 2px;
  color: #ffffff;
}
footer .left li em {
  display: inline-block;
  width: 18px;
  height: 18px;
  background-image: url(../assets/img/wa.png);
  margin-right: 5px;
  background-size: cover;
  vertical-align: -2px;
}
footer .right p {
  width: 129px;
  height: 129px;
}
footer .right {
  margin-top: 48px;
}
footer .right li {
  margin-left: 42px;
}
footer .right span {
  text-align: center;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 2px;
  color: #ffffff;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue